import { Routes } from '@angular/router';
import { ShellComponent } from './shell/shell.component';
import { HomeComponent } from './pages/home/home.component';
import { SubmitIdeaComponent } from './pages/submit-idea/submit-idea.component';
import { IdeaDetailsComponent } from './pages/idea-details/idea-details.component';
import { ChallengesComponent } from './pages/challenges/challenges.component';
import { MyIdeasComponent } from './pages/my-ideas/my-ideas.component';
import { FollowingComponent } from './pages/following/following.component';
import { LeaderboardComponent } from './pages/leaderboard/leaderboard.component';
import { AnalyticsComponent } from './pages/analytics/analytics.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { LoginComponent } from './pages/login/login.component';
import { authGuard } from './shared/auth/auth.guard';
import { loginGuard } from './shared/auth/login.guard';
import { committeeGuard } from './shared/auth/committee.guard';
import { CommitteeReviewBoardComponent } from './pages/committee-review-board/committee-review-board.component';

export const appRoutes: Routes = [
  { path: 'login', component: LoginComponent, canActivate: [loginGuard], title: 'Sign In' },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'feed' },
      { path: 'feed', component: HomeComponent, title: 'Home / Feed' },
      { path: 'submit-idea', component: SubmitIdeaComponent, title: 'Submit Idea' },
      { path: 'ideas/:id', component: IdeaDetailsComponent, title: 'Idea Details' },
      { path: 'challenges', component: ChallengesComponent, title: 'Challenges' },
      { path: 'my-ideas', component: MyIdeasComponent, title: 'My Ideas' },
      { path: 'following', component: FollowingComponent, title: 'Following' },
      { path: 'leaderboard', component: LeaderboardComponent, title: 'Leaderboard' },
      { path: 'analytics', component: AnalyticsComponent, title: 'Analytics' },
      { path: 'settings', component: SettingsComponent, title: 'Settings' },
      {
        path: 'committee/review-board',
        component: CommitteeReviewBoardComponent,
        canActivate: [committeeGuard],
        title: 'Committee / Review Board'
      }
    ]
  },
  { path: '**', redirectTo: '/login' }
];
